"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var QuickSuggestionsFull_1 = require("./components/QuickSuggestionsFull");
var isQuickSuggestionsOptionDirty_1 = require("./utils/isQuickSuggestionsOptionDirty");
var discardQuickSuggestionOption_1 = require("./actions/discardQuickSuggestionOption");
var saveQuickSuggestionOption_1 = require("./actions/saveQuickSuggestionOption");
var QuickSuggestionsOption = {
    key: 'quickSuggestions',
    titleStringKey: 'optionTitle_quickSuggestions',
    searchTermsStringKey: 'optionTitle_quickSuggestions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(QuickSuggestionsFull_1.default, null); },
        isDirty: isQuickSuggestionsOptionDirty_1.default,
        onSave: saveQuickSuggestionOption_1.default,
        onDiscard: discardQuickSuggestionOption_1.default,
    },
};
exports.default = QuickSuggestionsOption;
//# sourceMappingURL=QuickSuggestionsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-quick-suggestions-option/lib/QuickSuggestionsOption.js
// module id = 5131
// module chunks = 2